import { Form, Input, Switch, Select, Row, Col } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../../utilsTsx/universal/getList';

const LicenseEdit = (props: any) => {
    const apiId = 'license';
    const [form] = Form.useForm();
    const { defaultService } = props;
    const ref = useRef<any>(undefined);
    const [licenseData, setLicenseData] = useState<any>();
    const [licenseGroupData, setLicenseGroup] = useState<any>();
    const [roleData, setRoleData] = useState<any>();
    const [licenseTypeData, setLicenseTypeData] = useState<any>();
    const [userTypeData, setUserTypeData] = useState<any>();

    useEffect(() => {
        fetchApi.GET(defaultService, {
            apiId: 'license',
            apiExtend: 'showList',
        }).then((res) => {
            if (res.success) {
                setLicenseData(res.data);
            }
        });
        fetchApi.GET(defaultService, {
            apiId: 'licenseGroup',
            apiExtend: 'showList',
        }).then((res) => {
            if (res.success) {
                setLicenseGroup(res.data);
            }
        });
        fetchApi.GET(defaultService, {
            apiId: 'role',
            apiExtend: 'showList',
        }).then((res) => {
            if (res.success) {
                setRoleData(res.data);
            }
        });
        fetchApi.GET(defaultService, {
            apiId: 'generalData',
            apiVariable: 'licenseType@userType',
            apiExtend: 'showLists',
        }).then((res) => {
            if (res.success) {
                const { licenseType, userType } = res.data;
                setLicenseTypeData(licenseType);
                setUserTypeData(userType);
            }
        });
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        displayOptions: {
            width: 700,
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={10}>
                        <Form.Item label="ID" name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={14}>
                        <Form.Item
                            label="权限名"
                            name="licenseName"
                            rules={[{ required: true, message: '请输入权限名称!' }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={10}>
                        <Form.Item
                            label="权限组"
                            name="licenseGroupId"
                            rules={[{ required: true, message: '请选择权限组!' }]}
                        >
                            <Select
                                showSearch
                                placeholder="选择权限组"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {getList.general(licenseGroupData, {
                                    itemName: 'licenseGroupName',
                                })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={14}>
                        <Form.Item
                            label="路径"
                            name="pageUrl"
                            tooltip='权限路径'>
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={19}>
                        <Form.Item
                            label="类型"
                            name="licenseTypeIds"
                            tooltip='权限类型'
                        >
                            <Select
                                showSearch
                                mode='multiple'
                                placeholder="选择权限类型"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0} >
                                {getList.general(licenseTypeData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item label="排序" name="sort">
                            <Input type={'number'} />
                        </Form.Item>
                    </Col>

                    <Col span={10}>
                        <Form.Item
                            label="上级权限"
                            name="parentId"
                            rules={[{ message: '请选择上级权限!' }]}>
                            <Select
                                showSearch
                                placeholder="选择上级权限"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(licenseData, { itemName: 'licenseName', includeNull: true })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={14}>
                        <Form.Item label="图标" name="icon">
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={18}>
                        <Form.Item label="备注" name="memo">
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}
                        >
                            <Switch
                                checked={true}
                                checkedChildren="启用"
                                unCheckedChildren="关闭"
                            />
                        </Form.Item>
                    </Col>

                </Row>
            ),
        },
    };

    return <WebEditUniversal ref={ref} {...extendProps} />;
};

export default LicenseEdit;